const contains = (obj, str) => {
  return obj.toString().toLowerCase().includes(str.toLowerCase())
};

export default contains;


// WEBPACK FOOTER //
// ./App/components/modules/measurement-validator/utils/contains.js